<template>
  <div>
    <!-- Start Bradcaump area -->
    <div class="bradcaump_area bg_image--4">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="bradcaump_inner text-center">
              <h2 class="bradcaump-title">联系我们 Contact Us</h2>
              <nav class="bradcaump-content">
                <b-link class="breadcrumb_item" to="/home">Home</b-link>
                <span class="brd-separetor">/</span>
                <span class="breadcrumb_item active">Contact Us</span>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Bradcaump area -->
    <!-- v-html="contactArticle.content" -->
    <!-- 百度地图  -->
    <div class="contact_area pt--10 pb--50">
      <div class="container">
        <div class="row">
          <div class="col-lg-12"><div id="baiduMap"></div></div>
        </div>
        <div class="row pt--50">
          <div class="col-lg-5 col-md-5 col-12">
            <div class="contact_adress">
              <div class="ct_address">
                <h3 class="ct_title">联系方式 Location& Details</h3>
                <p>康洁来（北京）生物科技有限公司 <br>ChemClean (Beijing) BioTech Co., Ltd.</p>
              </div>

              <div class="address_wrapper">
                <div class="address">
                  <div class="icon"><i class="ti-location-pin"></i></div>
                  <div class="contact-info-text">
                    <p>
                      <span>ADD:</span>
                      北京市西城区宣武门外大街6、8、10、12、16、18号6号楼15层1507 <br>
                      Suite 1507, 15th Floor, Building 6, No.6,8,10,12,16,18 Xuanwumenwai Avenue, Xicheng District, Beijing, PRC
                    </p>
                  </div>
                </div>

                <div class="address">
                  <div class="icon"><i class="ti-email"></i></div>
                  <div class="contact-info-text">
                    <p>
                      <span>Email:</span>
                      sales@chemcleanchina.com
                      <br>
                      sales1@chemcleanchina.com
                    </p>
                  </div>
                </div>

                <div class="address">
                  <div class="icon"><i class="ti-mobile"></i></div>
                  <div class="contact-info-text">
                    <p>
                      <span>TEL:</span>
                      0086-572-5817-231
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-7 col-md-7 col-12 sm-mt--30">
            <div class="contact_form">
              <h3 class="ct_title">留言 Send Us a Message</h3>
              <b-form @submit="onSubmit" @reset="onReset" v-if="show" novalidate>
                <b-form-group id="input-group-1" label-for="input-1">
                  <b-form-input id="input-1" v-model="form.name" :state="null"  placeholder="您的姓名 Your name"></b-form-input>
                  <b-form-invalid-feedback :state="validationName">请提供您的姓名 need your name </b-form-invalid-feedback>
                  <!--                  <b-form-valid-feedback :state="validation"  >
                  </b-form-valid-feedback> -->
                </b-form-group>

                <b-form-group id="input-group-2" label-for="input-2">
                  <b-form-input id="input-2" v-model="form.contact"  placeholder="联系方式 Phone or email"></b-form-input>
                  <b-form-invalid-feedback :state="validationContact">请提供您的手机号或邮箱地址 need your phone or email</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="input-group-3" label-for="input-3">
                  <b-form-radio-group id="radio-group-2" v-model="form.type" >
                    <b-form-radio value="产品">产品Product</b-form-radio>
                    <b-form-radio value="询价">询价Price</b-form-radio>
                    <b-form-radio value="其他">其他Other</b-form-radio>
                  </b-form-radio-group>
                  <b-form-invalid-feedback :state="validationType">请选择您的诉求 Select your requirement</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="input-group-4" label-for="input-4">
                  <b-form-textarea id="input-4" v-model="form.desc"  placeholder="需要咨询的问题 Question Details" rows="3" max-rows="6"></b-form-textarea>
                  <b-form-invalid-feedback :state="validationDesc">请输入需咨询的内容 Need Details </b-form-invalid-feedback>
                </b-form-group>

                <b-button type="submit" variant="primary" squared>提交</b-button>
                <b-button type="reset" variant="danger" style="margin-left: 5px;" squared>取消</b-button>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Contact Area -->
  </div>
</template>

<script>
export default {
    data () {
        return {
            form: {
                name: '',
                contact: '',
                type: '',
                desc: ''
            },
            contactArticle: '',
            show: true
        }
    },
    computed: {
    // 表单验证
        validationName () {
            return this.form.name.length > 3 && this.form.name.length < 25
        },
        validationContact () {
            return this.form.contact.length > 3 && this.form.name.length < 25
        },
        validationType () {
            return this.form.type !== '' && this.form.type !== null
        },
        validationDesc () {
            return this.form.desc.length > 0 && this.form.desc.length < 100
        }
    },
    methods: {
    // 提交客户咨询表单
        onSubmit (evt) {
            evt.preventDefault()
            let that = this
            let formData = that.form
            if (that.validationName && that.validationContact && that.validationType && that.validationDesc) {
                console.log('验证通过')
                this.$axios
                    .post('/api/question/', {
                        params: formData
                    })
                    .then(function (res) {
                        if (res.data.code === 'success') {
                            const h = that.$createElement
                            that.$notify({
                                title: 'Congratulations',
                                message: h('i', { style: 'color: #484848' }, '提交成功，我们会尽快答复！'),
                                type: 'success',
                                position: 'top-left'
                            })
                        } else if (res.data.code === 'fail') {
                            const h = that.$createElement
                            that.$notify({
                                title: 'Ooops',
                                message: h('i', { style: 'color: #ff5500' }, '您今日咨询次数已达上限'),
                                type: 'error',
                                position: 'top-left'
                            })
                        } else {
                            const h = that.$createElement
                            that.$notify({
                                title: 'Ooops',
                                message: h('i', { style: 'color: #ff5500' }, '服务器繁忙，请稍后重试'),
                                type: 'error',
                                position: 'bottom-left'
                            })
                        }
                        that.resetForm()
                    })
                    .catch(function (error) {
                        console.log(error)
                        const h = that.$createElement
                        that.$notify({
                            title: 'Ooops',
                            message: h('i', { style: 'color: #ff5500' }, '服务器繁忙，请稍后重试'),
                            type: 'error',
                            position: 'top-left'
                        })
                        that.resetForm()
                    })
            } else {
                console.log('验证不通过')
                return false
            }
        },
        onReset (evt) {
            evt.preventDefault()
            // Reset our form values
            this.form.name = ''
            this.form.contact = ''
            this.form.type = null
            this.form.desc = ''
            this.show = false
            this.$nextTick(() => {
                this.show = true
            })
        },
        resetForm () {
            this.form.name = ''
            this.form.contact = ''
            this.form.type = null
            this.form.desc = ''
            this.show = false
            this.$nextTick(() => {
                this.show = true
            })
        }
    },
    created () {
        var that = this
        this.$axios
            .get('/api/getcontactus/', {
                params: {
                    pk: 1
                }
            })
            .then(function (response) {
                that.contactArticle = response.data
            })
            .catch(function (error) {
                console.log(error)
            })
    },
    mounted () {
        var map = new BMapGL.Map('baiduMap')
        // 创建百度地图实例
        var point = new BMapGL.Point(116.382188, 39.903804)
        map.centerAndZoom(point, 19) // 初始化地图,设置中心点坐标和地图级别
        map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
        map.setHeading(45)
        map.setTilt(45)
        var opts = {
            position: point, // 指定文本标注所在的地理位置
            offset: new BMapGL.Size(30, -30) // 设置文本偏移量
        }
        var label = new BMapGL.Label('康洁来（北京）', opts) // 创建文本标注对象
        label.setStyle({
            color: '#000',
            fontSize: '18px',
            height: '30px',
            lineHeight: '30px',
            fontFamily: '微软雅黑'
        })
        map.addOverlay(label)
    }
}
</script>

<style>
#baiduMap {
  height: 350px;
  width: 100%;
}
.el-input__inner {
  background: transparent;
  border: 1px solid #dddddd;
  color: #252525;
  font-size: 14px;
  height: 48px;
  margin-bottom: 30px;
  padding: 2px 30px;
  width: 100%;
}
.form_button {
  background-color: #252525;
  border: 1px solid #252525;
  color: #ffffff;
  display: inline-block;
  font-size: 16px;
  padding: 11px 28px 12px;
  transition: all 0.3s ease 0s;
  width: inherit;
}
.form_button:hover {
  background-color: #000000;
  border-color: #000000;
  color: #ffffff;
  opacity: 0.7;
}
</style>
